import { useEffect } from 'react';

import { useConsumeQueryParam } from '@/hooks/useConsumeQueryParam';

import { OPEN_CHAT_CONVERSATION_ID_QUERY_PARAM } from '../householdChatDeepLink';

interface UseOpenChatConversationFromDeepLinkArgs {
  openChat: () => void;
  selectConversation: (conversationId: string) => void;
}

/**
 * Deep-link: open the household agent on a specific conversation when arriving
 * with the chat conversation param (e.g. from a validation-questions
 * notification for a household the user wasn't already viewing).
 *
 * The param is consumed before the chat is opened, so unrelated re-renders
 * can't re-open it while a later navigation carrying a different ID still
 * re-triggers the effect.
 */
export function useOpenChatConversationFromDeepLink({
  openChat,
  selectConversation,
}: UseOpenChatConversationFromDeepLinkArgs) {
  const { value: conversationId, consume: consumeConversationId } =
    useConsumeQueryParam(OPEN_CHAT_CONVERSATION_ID_QUERY_PARAM);

  useEffect(() => {
    if (!conversationId) return;

    consumeConversationId();
    selectConversation(conversationId);
    openChat();
  }, [conversationId, consumeConversationId, openChat, selectConversation]);
}
